<template>
	<div class="nav-main">
		<div class="menus">
			<div class="top-menu">
				<template v-for="(m,index) in menus">
					<div class="menu-one" :class="{'activeMe':oneMe == index,'activeHoverMe':oneMeHover == index}"
						@click="oneMenuClick(m.path,index)" v-on:mouseenter="oneMenuMou(index)"
						@mouseleave="oneMenuMouout">
						<div class="menu-icon">
							<!-- <i class="el-icon-user"></i> -->
							<img v-if="index == oneMe" :src="m.aicon" class="icon" />
							<img v-else :src="m.icon" class="icon" />
						</div>
						<div class="name">
							<div class="nameContent">{{$t(`menu.${m.name}`)}}</div>
							<span v-if="m.children.length > 0" class="sanjiao"></span>
						</div>
					</div>
					<div class="menu-two" v-if="m.isShow">
						<!-- <div class="menu-icon"></div> -->
						<router-link :to="{path:tm.path}" v-for="(tm,k) in m.children">
							<div class="name" :class="{'activeName':tm.active}" @click="twoMenuClick(index,k)">
								{{$t(`menu.${tm.name}`)}}
							</div>
						</router-link>
					</div>
				</template>
				<!-- <div style="height: 150px;"></div> -->
			</div>
			<div class="last-menu">
				<div class="menu-three" v-for="(lm,index) in lastMenu" :class="{'activeMe':index == lastMe}"
					@click="lastMenuClick(lm.path,index)">
					<div class="menu-icon">
						<img v-if="index == lastMe" :src="lm.aicon" class="icon" />
						<img v-else :src="lm.icon" class="icon" />
					</div>
					<div class="name">{{$t(`menu.${lm.name}`)}}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		mapMutations
	} from 'vuex'
	export default {
		name: 'Navbar',
		data() {
			return {
				menus: [{
						name: 'personal_center',
						icon: require('../../assets/icon/person@2x.png'),
						aicon: require('../../assets/icon/person@2x1.png'),
						path: '/user/personal',
						isShow: false,
						children: [{
								name: "Writer_Center",
								path: '/user/information',
								active: false
							},
							//先取消次菜单
							// {
							// 	name: 'my_record',
							// 	path: '/user/record',
							// 	active: false
							// },
						],
					},
					{
						name: 'Works_management',
						icon: require('../../assets/icon/records@2x.png'),
						aicon: require('../../assets/icon/records@2x1.png'),
						path: '/work/mywork',
						isShow: false,
						children: [{
								name: 'My_creation',
								path: '/work/mywork',
								active: false
							},
							{
								name: 'new_work',
								path: '/work/new',
								active: false
							},
							// {name:'作品设定',path:'/work/setup',active:false},
							// {name:'去写作',path:'/work/writing',active:false},
						],
					},
					// 作者管理
					// {
					// 	name: 'author_management',
					// 	icon: require('../../assets/icon/person@2x.png'),
					// 	aicon: require('../../assets/icon/person@2x1.png'),
					// 	path: '/work/mywork',
					// 	isShow: false,
					// 	children: [{
					// 			name: 'author1',
					// 			path: '/author/authorManege',
					// 			active: false
					// 		}
					// 		// {name:'作品设定',path:'/work/setup',active:false},
					// 		// {name:'去写作',path:'/work/writing',active:false},
					// 	],
					// },

					// {
					// 	name: 'interactive_space',
					// 	icon: require('../../assets/icon/accounts@2x.png'),
					// 	aicon: require('../../assets/icon/accounts@2x1.png'),
					// 	path: '/interactive/space',
					// 	isShow: false,
					// 	children: [
					// 		// {name:'二级菜单'},
					// 		// {name:'二级菜单'},
					// 		// {name:'二级菜单'},
					// 	],
					// },
					// {
					// 	name: 'data_center',
					// 	icon: require('../../assets/icon/shoplist@2x.png'),
					// 	aicon: require('../../assets/icon/shoplist@2x1.png'),
					// 	path: '/data/center',
					// 	isShow: false,
					// 	children: [{
					// 			name: 'number_readings',
					// 			path: '/data/reading',
					// 			active: false
					// 		},
					// 		{
					// 			name: 'Article_unlock',
					// 			path: '/data/articleUnlock',
					// 			active: false
					// 		},
					// 		{
					// 			name: 'Likes',
					// 			path: '/data/likes',
					// 			active: false
					// 		},
					// 		{
					// 			name: 'Favorites',
					// 			path: '/data/collections',
					// 			active: false
					// 		},
					// 	],
					// },
					{
						name: 'my_income',
						icon: require('../../assets/icon/send@2x.png'),
						aicon: require('../../assets/icon/send@2x1.png'),
						path: '/income/home',
						isShow: false,
						children: [{
							name: 'Work_income',
							path: '/income/workIncome',
							active: false
						}
						,
						{
							name: 'Apply_withdrawal',
							path: '/income/Applywithdrawal',
							active: false
						}
						],
						
					},
					
					// 更新时屏蔽了合同信息start
					{
						name: 'con_info',
						icon: require('../../assets/icon/send@2x.png'),
						aicon: require('../../assets/icon/send@2x1.png'),
						path: '/contractInfo/coninfo',
						isShow: false,
						children: [{
							name: 'con_info',
							path: '/contractInfo/coninfo',
							active: false
						}, ],
					},
					// 更新时屏蔽了合同信息end

					// { 签署审核放到小说管理
					// 	name: 'works_reviewer',
					// 	icon: require('../../assets/icon/records@2x.png'),
					// 	aicon: require('../../assets/icon/records@2x1.png'),
					// 	path: '/reviewer/reviewerWork',
					// 	isShow: false,
					// 	children: [{
					// 			name: 'reviewerWork',
					// 			path: '/reviewer/reviewerWork',
					// 			active: false
					// 		},
					// 	],
					// }
				],
				lastMenu: [{
						name: 'setting',
						icon: require('../../assets/icon/settings@2x.png'),
						aicon: require('../../assets/icon/settings@2x1.png'),
						path: '/setting',
					},
					{
						name: 'FAQs_and_Help',
						icon: require('../../assets/icon/info@2x.png'),
						aicon: require('../../assets/icon/info@2x1.png'),
						path: '/answer',
					},
					{
						name: 'loginOut',
						icon: require('../../assets/icon/Rounded@2x.png'),
						aicon: require('../../assets/icon/Rounded@2x1.png'),
						path: '',
					},
				],
				oneMe: 0,
				lastMe: 90,
				oneMeHover: 0,
			}
		},
		methods: {
			...mapMutations(['loginOut']),
			oneMenuMou(index) {
				this.oneMeHover = index
			},
			oneMenuMouout() {
				this.oneMeHover = 90
			},
			oneMenuClick(path, index) {
				this.lastMe = 90
				this.oneMe = index
				this.menus[index].isShow = !this.menus[index].isShow
				if (path == '/interactive/space') {
					this.$router.push({
						path: path
					})
				}
			},
			lastMenuClick(path, index) {
				if (path == '') {
					this.$confirm(this.$t('login.isLogout'), this.$t('interact.hint'), {
						confirmButtonText: this.$t('interact.confirm'),
						cancelButtonText: this.$t('interact.cancel'),
						type: 'warning'
					}).then(() => {
						this.loginOut()
						this.$router.replace({
							path: '/login'
						})

					}).catch(() => {

					});
					return
				}
				this.lastMe = index
				this.oneMe = 90
				this.$router.push({
					path: path
				})
			},
			twoMenuClick(index, k) {
				this.oneMe = index
				this.menus.forEach((e) => {
					e.children.forEach((c) => {
						c.active = false
					})
				})
				this.menus[index].children[k].active = true
			},
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.nav-main {
		height: 100%;
		overflow-y: auto;
		position: relative;
		display: flex;

		.menus {
			width: 100%;
			padding-top: 20px;
			display: flex;
			justify-content: space-between;
			flex-direction: column;

			.top-menu {
				flex: 1;
				width: 100%;
				// height:calc(100vh - 70px);
				// 	overflow-y: auto;
			}

			.menu-one {
				height: 36px;
				display: flex;
				justify-content: flex-start;
				align-items: center;
				cursor: pointer;

				.menu-icon {
					min-width: 30px;
					max-width: 30px;
					height: 30px;
					margin-left: 20px;
					margin-right: 15px;
					display: flex;
					justify-content: center;
					align-items: center;

					.icon {
						width: 18px;
						height: 18px;
					}
				}

				.name {
					font-size: 14px;
					text-align: left;
					display: flex;
					justify-content: flex-start;
					align-items: center;
					line-height: 36px;
					padding-right: 10px;

					.nameContent {
						word-break: break-all;
						text-overflow: ellipsis;
						display: -webkit-box;
						-webkit-box-orient: vertical;
						-webkit-line-clamp: 1;
						overflow: hidden;

					}

					.sanjiao {
						flex: 0 0 7px;
						width: 7px;
						height: 7px;
						margin-left: 10px;
						background-image: url('../../assets/icon/arrow@2x.png');
						background-size: 100%;
						background-repeat: no-repeat;
					}
				}
			}

			.menu-one:hover {}

			.menu-two {
				.name {
					height: 30px;
					font-size: 14px;
					line-height: 30px;
					padding-left: 65px;
					text-align: left;
					cursor: pointer;
				}

				.name:hover {
					color: #FF8900;
				}

				.activeName {
					color: #FF8900;
				}
			}

			.last-menu {
				width: 100%;
				// width: 210px;
				// position: fixed;
				// bottom: 0;
				// left: 0;
				// margin-top: 15px;
				padding-top: 10px;
				padding-bottom: 10px;
				border-top: 1px solid #C4C4C4;
				background-color: #FFFFFF;

				.menu-three {
					height: 45px;
					display: flex;
					justify-content: flex-start;
					align-items: center;
					cursor: pointer;

					.menu-icon {
						min-width: 30px;
						max-width: 30px;
						height: 30px;
						margin-left: 20px;
						margin-right: 15px;
						display: flex;
						justify-content: center;
						align-items: center;

						.icon {
							width: 18px;
							height: 18px;
						}
					}

					.name {
						// width: 90px;
						font-size: 14px;
						text-align: left;
					}
				}

				.menu-three:hover {
					background-color: #FFF2E2;
					color: #FF8900;
				}
			}

			.activeMe {
				background-color: #FFF2E2;
				color: #FF8900;
				box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);

				.sanjiao {
					width: 7px;
					height: 7px;
					margin-left: 10px;
					background-image: url('../../assets/icon/arrow@2x1.png') !important;
					background-size: 100%;
					background-repeat: no-repeat;
				}
			}

			.activeHoverMe {
				background-color: #FFF2E2;
				color: #FF8900;
			}
		}
	}
</style>